/*
https://about.patisserie-flower.jp/list からお知らせ3件を取得し表示する

about.patisserie-flower.jp 側には
header("Access-Control-Allow-Origin: https://patisserieflower-uca.myshopify.com");
を設定
*/
$(function() {
    $.ajax({
        type: 'GET',
        url: "https://api.abistudio.com/patisserie-flower-news.php",
        dataType: 'html',
        success: function(data) {
            var c = 0;
            $(data).find('#main').find('li').each(function(){
                c++;
                if (c > 3) { // 3件表示したら処理終了
                    return false;
                }
                $('#news').append($('<li/>').html('<a href="' + $(this).find('a').attr('href') + '">' + $(this).find('a').text() + "</a>"));
            });
        }, error:function(e) {
            console.log(e);
        }
    });
});
